import type { Template } from '@cognite/apm-client';
import { useRecoilState } from 'recoil';

import { selectedTemplateAtom } from '../../state';

interface SelectTemplateHook {
  selectedTemplate: Template | undefined;
  setSelectedTemplate: (template: Template | undefined) => void;
}

/**
 * Custom React hook to manage the selection of a template using global state.
 *
 * This hook provides:
 * - Access to the currently selected template from global state (`selectedTemplateAtom`)
 * - A setter function to update the selected template
 *
 * @returns {{
 *   selectedTemplate: Template | undefined,
 *   setSelectedTemplate: (template: Template | undefined) => void
 * }} An object containing the currently selected template and a setter to update it.
 */

export const useTemplateSelection = (): SelectTemplateHook => {
  const [selectedTemplate, _setSelectedTemplate] =
    useRecoilState(selectedTemplateAtom);

  const setSelectedTemplate = (template: Template | undefined) => {
    _setSelectedTemplate(template);
  };

  return {
    selectedTemplate,
    setSelectedTemplate,
  };
};
